import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import { Button } from 'Common/Supplyvue-ui/Button'
import Typography from '@mui/material/Typography'

// Wrapper with minWidth 600px
export const ContentWrapper = styled(Box)({
  minWidth: '600px',
})

// Modal action button with margin and minWidth
export const ModalActionButton = styled(Button)({
  marginLeft: '20px',
  minWidth: '105px',
})

// Label with margin bottom
export const StyledTypography = styled(Typography)({
  marginBottom: '8px',
})

// Progress element with margin right (assuming some Box or div)
export const Progress = styled(Box)({
  marginRight: '8px',
})

// Footer flex container aligned right
export const StyledFooter = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'flex-end',
})
